var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { ref: "flipRef", staticClass: "flip down" }, [
      _c("div", { ref: "frontNodeRef", staticClass: "digital front number0" }),
      _c("div", { ref: "backNodeRef", staticClass: "digital back number1" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }